import styled from "styled-components";

export const Container = styled.div`
    // width: 90%;
    // position: relative;
    overflow:hidden;
    // max-width: 1420px;
    // margin: auto;
   
    // h1{
    //     text-align: left;
    //     margin-bottom: 20px;
    //     font-weight: bold;
    //     font-size: 1.8em;
    //     letter-spacing: 2px;
    //     color: #4e3628;
    // }
    // .formContent{
    //     background-color: white;
    //     width: 100%;
    //     margin: auto;
    //     border-radius: 10px;

    //     form{
    //         padding: 20px;
    //         margin-bottom: 3rem;

    //         button{
    //             background-color: #4e3628;
    //             color: #fbe777;
    //             text-transform: uppercase;
    //             font-weight: 500;
    //         }
    //     }
    // }
    // hr{
    //     margin: 3rem 0px;
    //     border-color: #d2d0c1;
    // }
    // .vendasContainer{
    //     max-width: 1420px;
    //     display: flex;
    //     margin: 2rem auto;
    // }
    // .validate{
    //     display: flex;
    //     justify-content: space-between;
    //     align-items: center;
    // }
   
    // @media only screen and (max-width: 1080px) {
    //     .validate{
    //         gap: 10px;
    //         flex-direction: column;
    //     }
    // }
`;
